import translationEN from '~common/Internationalisation/langs/en/translation.json';
import translationRU from '~common/Internationalisation/langs/ru/translation.json';
import translationPT from '~common/Internationalisation/langs/pt/translation.json';

export const languageList = [
  {
    label: 'English',
    value: 'en',
    translation: translationEN,
    isoCode: 'EN',
  },
  {
    label: 'Português',
    value: 'pt',
    translation: translationPT,
    isoCode: 'PT',
  },
];